/**
 *
 * AuthenticatedRoute
 *
 */

import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Analytics from '@cashfree-intl/analytics';
import { useSearchParams, useLocation } from 'react-router-dom';

import { isNotProd } from 'utils/constants';
import MerchantProvider from '../../providers/MerchantProvider';

// Hooks
import { useAuth } from '../../hooks/useAuth';
import {
  getItemFromLocalStorage,
  redirectToCommonAuthLogin,
} from '../../utils/common';

export const AuthenticatedRoute = ({ children }) => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const env = searchParams.get('env') || 'prod';
  let includeMerchantProvider = true;

  if (pathname && pathname.split('/').pop() === 'tnc')
    includeMerchantProvider = false;

  const { userObj } = useAuth();
  userObj.populateCfToken();

  useEffect(() => {
    if (getItemFromLocalStorage('merchantToken'))
      Analytics.init({
        product:
          pathname && pathname.split('/').pop() === 'landing' ? 'CDB' : 'PG',
        token: getItemFromLocalStorage('merchantToken'),
        isDebug: isNotProd,
      });
  }, []);

  if (
    !userObj ||
    !userObj.cfToken ||
    !userObj.cfToken[env] ||
    !userObj.cfToken[env].token
  ) {
    if (
      !getItemFromLocalStorage('merchantToken') &&
      !sessionStorage.getItem('referrerUrl')
    )
      sessionStorage.setItem('referrerUrl', window.location.href);
    redirectToCommonAuthLogin();
    return null;
  }
  return includeMerchantProvider ? (
    <MerchantProvider>{children}</MerchantProvider>
  ) : (
    <>{children}</>
  );
};

AuthenticatedRoute.propTypes = {
  children: PropTypes.any,
};

export default memo(AuthenticatedRoute);
